import React from 'react';
import ScrollToBottom from 'react-scroll-to-bottom';
import Message from './Message/Message';
import './Messages.css'


const Messages = ({messages, name, room}) => {

return (
		<ScrollToBottom className="messages">
			{messages.map((message, index) => 
				<div className="messages__inner" key={index}>
					<Message message={message} name={name}/>
				</div>)}
		</ScrollToBottom>
	)
}

export default Messages